import React from "react";
import { Text } from "@foleon/atomic";

export const TargetsDescription = () => {
	return (
		<div>
			<Text.Title style={{ marginBottom: "0px", textAlign: "center" }}>
				Document Targets
			</Text.Title>
			<Text.Paragraph
				style={{ marginBottom: "0px", textAlign: "center" }}
			>
				You can set a target and keep track of the progress of the
				current document by clicking on the buttons below.
			</Text.Paragraph>
		</div>
	);
};

export default TargetsDescription;
